import React, { useState, useEffect, useRef } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import selectDownArrow from "../../../assets/images/selectDownArrow.svg";

const SearchableSelect = ({
  label,
  placeholder = "Select",
  options = [],
  value = "",
  onChange,
  disabled = false,
  error,
}) => {
  const [search, setSearch] = useState("");
  // Kept separate from `search` so opening the dropdown always shows the full
  // list even when a value is already selected in the input.
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    setSearch(value || "");
    if (disabled) {
      setOpen(false);
      setQuery("");
    }
  }, [value, disabled]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filtered = (options || []).filter((o) =>
    (o.label || "").toLowerCase().includes(query.toLowerCase().trim()),
  );

  const toggleDropdown = () => {
    if (open) {
      setOpen(false);
    } else {
      setQuery("");
      setOpen(true);
    }
  };

  const openDropdown = () => {
    setQuery("");
    setOpen(true);
  };

  return (
    <Form.Group className="custom-form">
      {label && (
        <Form.Label className="color-head">
          {typeof label === "string" && label.trim().endsWith("*") ? (
            <>
              {label.replace(/\s*\*$/, "")}{" "}
              <span className="text-danger">*</span>
            </>
          ) : (
            label
          )}
        </Form.Label>
      )}
      <div
        className={`country-dropdown-wrapper ${disabled ? "disabled" : ""}`}
        ref={containerRef}
      >
        <InputGroup
          className="country-search-box"
          onClick={() => {
            if (!disabled) toggleDropdown();
          }}
        >
          <Form.Control
            type="text"
            className="country-input"
            placeholder={placeholder}
            value={search}
            disabled={disabled}
            onChange={(e) => {
              const v = e.target.value;
              setSearch(v);
              setQuery(v);
              if (!disabled) setOpen(true);
              if ((options || []).length === 0 && !disabled) {
                onChange(v);
              }
              if (v.trim() === "" && !disabled) onChange("");
            }}
          />
          <InputGroup.Text
            className="dropdown-arrow-wrapper"
            onClick={(e) => {
              e.stopPropagation();
              if (!disabled) openDropdown();
            }}
            style={{
              backgroundColor: "transparent",
              border: "none",
            }}
          >
            <img
              src={selectDownArrow}
              alt="CaretDown"
              className="dropdown-arrow"
            />
          </InputGroup.Text>
        </InputGroup>

        {open && (
          <div className="country-dropdown-list">
            {filtered.length > 0 ? (
              filtered.map((o) => (
                <div
                  key={o.value}
                  className={`country-option ${disabled ? "disabled" : ""}`}
                  onClick={() => {
                    if (!disabled) {
                      onChange(o.value);
                      setOpen(false);
                    }
                  }}
                  role="button"
                  tabIndex={disabled ? -1 : 0}
                >
                  {o.label}
                </div>
              ))
            ) : (
              <div className="country-option">No data found</div>
            )}
          </div>
        )}
      </div>
      {error && <div className="text-danger small mt-1">{error}</div>}
    </Form.Group>
  );
};

export default SearchableSelect;
